// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"58b428ee","423":"c91c25fa"}[chunkId] + ".chunk.css";
};